<ng-template #annotationTpl let-source="source">
	@let layout = getAnnotationLayout(source.data.boundingBox);
	<div
		class="absolute pointer-events-none reach-pdf-chunk-annotation"
		[attr.data-source-id]="source.id"
		[class.reach-pdf-chunk-annotation-normalized]="layout.normalized"
		[style.--bbTop]="layout.top"
		[style.--bbLeft]="layout.left"
		[style.--bbWidth]="layout.width"
		[style.--bbHeight]="layout.height"
	>
		<div
			class="rounded-0.25 w-full h-full bg-primary/20 reach-pdf-chunk-highlight"
			[class.invisible]="$highlightOnly() && $selectedSourceId().id !== source.id"
		></div>

		@if (!$highlightOnly()) {
			<div
				class="top-0 left-0 flex absolute items-center justify-center [transform:translatex(calc(-100%_-_4px))]"
			>
				<div
					class="rounded-circle text-xxs w-2 h-2 fc-white bg-primary flex items-center justify-center"
				>
					{{ source.inlineNumber }}
				</div>
			</div>

			<button
				tooltip="Translate"
				class="translation-button p-0.5 rounded-1 shadow-z1 items-center justify-center pointer-events-all"
				(click)="translateChunk(source)"
			>
				<i class="icon-translations"></i>
			</button>
		}
	</div>
</ng-template>

<ng-template #separator>
	<div class="overflow-hidden w-px flex items-center justify-center">
		<div buttonIcon size="S" [disabled]="true">
			<div class="w-px h-fs-icon bg-line-230"></div>
		</div>
	</div>
</ng-template>

<ng-template #toolbarTpl>
	<div class="py-1 w-full bg-280">
		<div
			class="p-0.5 rounded-1.5 w-full bg-170 flex items-center justify-start reach-pdf-border-box"
		>
			<div class="flex-none overflow-hidden w-0 h-full flex items-center justify-start">
				<div buttonIcon size="S">
					<div class="w-fs-icon h-fs-icon"></div>
				</div>
			</div>
			@if (!$loading()) {
				<div class="flex-auto gap-2 overflow-hidden flex items-center justify-center">
					<div class="flex-none flex items-center justify-start">
						<button
							buttonIcon
							[class.sidemenu-btn]="$sidebarVisible()"
							size="S"
							[active]="$sidebarVisible()"
							(click)="toggleSidebar()"
						>
							<i class="icon-sidebar"></i>
						</button>
					</div>

					<div class="flex-auto flex items-center justify-center">
						<ng-container [ngTemplateOutlet]="separator"></ng-container>
						<div class="px-2 gap-0.25 truncate flex items-center justify-start">
							<button
								buttonIcon
								size="S"
								[disabled]="$page() <= 1"
								(click)="decreasePage()"
							>
								<i class="icon-chevron chevron-left"></i>
							</button>
							<input
								#pageInput
								type="text"
								[inputValidator]="$removeEverythingExceptIntegers()"
								[(ngModel)]="$page"
								(keydown.arrowUp)="$event.preventDefault(); increasePage()"
								(keydown.arrowDown)="$event.preventDefault(); decreasePage()"
								class="p-0.5 rounded-0.75 w-4 bg-280 text-center border-none"
							/>
							<span class="fc-800">/ {{ $maxPage() }}</span>
							<button
								buttonIcon
								size="S"
								[disabled]="$page() >= $maxPage()"
								(click)="increasePage()"
							>
								<i class="icon-chevron chevron-right"></i>
							</button>
						</div>

						<ng-container [ngTemplateOutlet]="separator"></ng-container>

						@if (!$smallScreen()) {
							<div class="px-2 gap-0.25 flex items-center justify-start">
								<button buttonIcon size="S" (click)="zoomOut()">
									<i class="icon-minus"></i>
								</button>

								<div class="relative">
									<select
										[(ngModel)]="$zoomValue"
										class="text-center reach-pdf-zoom-select"
									>
										@for (zoomItem of $allZooms(); track zoomItem.key) {
											<option class="fc-800" [value]="zoomItem.value">
												{{ zoomItem.label }}
											</option>
										}
									</select>

									<div
										class="top-0 left-0 rounded-0.75 w-full h-full fc-500 bg-280 flex absolute items-center justify-center pointer-events-none"
									>
										{{ $zoomLabel() }}
									</div>
								</div>

								<button buttonIcon size="S" (click)="zoomIn()">
									<i class="icon-plus"></i>
								</button>
							</div>

							<ng-container [ngTemplateOutlet]="separator"></ng-container>
						}
					</div>

					<div class="flex-none gap-1 flex items-center justify-end">
						@if ($smallScreen()) {
							<!--  -->
							@if ($zoomValue() !== DEFAULT_ZOOM_LEVEL) {
								<div class="flex relative flex-col items-start justify-start">
									<button buttonIcon size="S" (click)="resetZoom()">
										<i class="icon-zoom-in"></i>
									</button>
								</div>
							}
							<!--  -->
						}

						<button buttonIcon size="S" (click)="rotateRight()">
							<i class="icon-rotate-right"></i>
						</button>

						<button buttonIcon size="S" (click)="requestFullscreen()">
							@if ($fullscreenEnabled()) {
								<i class="icon-fullscreen-inside"></i>
							} @else {
								<i class="icon-fullscreen-outside"></i>
							}
						</button>
					</div>
				</div>
			}
		</div>
	</div>
</ng-template>

<ng-template #sidebarTpl>
	<div id="viewsManager" class="h-full bg-280 top-0! border-0!">
		<div class="w-full h-full flex flex-col items-start justify-start">
			<div class="flex-none w-full pointer-events-none">
				<ng-container [ngTemplateOutlet]="toolbarTpl"></ng-container>
			</div>
			<div class="flex-auto overflow-hidden w-full relative">
				<pdf-sidebar-content class="w-full"></pdf-sidebar-content>
			</div>
		</div>
		<div id="viewsManagerResizer" class="hidden"></div>
	</div>
</ng-template>

<div
	#pdfWrapper
	class="w-full h-full relative"
	[class.p-1]="$fullscreenEnabled()"
	[class.bg-190]="$fullscreenEnabled()"
>
	@if ($renderPdf()) {
		<div
			class="w-full h-full flex flex-col items-start justify-start"
			[class.gap-1]="!$hideToolbar()"
		>
			<ngx-extended-pdf-viewer
				#viewer
				class="flex-auto overflow-hidden w-full h-full block"
				backgroundColor="var(--color-bg-190)"
				[showToolbar]="!$hideToolbar()"
				[customToolbar]="$hideToolbar() ? undefined : toolbarTpl"
				[customSidebar]="sidebarTpl"
				[minifiedJSLibraries]="false"
				[src]="$pdfUrl()"
				[authorization]="$authorization()"
				[textLayer]="false"
				[handTool]="false"
				[activeSidebarView]="1"
				[disableForms]="true"
				[httpHeaders]="$customHeaders()"
				[(zoom)]="$zoomValue"
				[(page)]="$page"
				[(sidebarVisible)]="$sidebarVisible"
				(currentZoomFactor)="$currentZoomFactor.set($event)"
				(annotationLayerRendered)="onAnnotationLayerRendered($event)"
				(pdfLoadingStarts)="onPdfStartsLoading()"
				(pdfLoaded)="onPdfLoaded($event)"
				(pdfLoadingFailed)="onPdfFailed()"
				(progress)="onProgress($event)"
			></ngx-extended-pdf-viewer>

			@if ($chunkToTranslate(); as chunkToTranslate) {
				<app-chunk-translator
					class="flex-none w-full h-25"
					[chunkInfo]="chunkToTranslate"
					(close)="closeTranslation()"
				></app-chunk-translator>
			}
		</div>
	} @else {
		<div class="w-full h-full bg-190"></div>
	}

	<div
		class="top-0 left-0 w-full h-full flex absolute flex-col items-start justify-start pointer-events-none z-2"
	>
		@if (!$hideToolbar()) {
			<div class="flex-none w-full invisible">
				<ng-container [ngTemplateOutlet]="toolbarTpl"></ng-container>
			</div>
		}
		<div
			class="rounded-1.5 flex-auto overflow-hidden w-full flex relative items-center justify-center"
		>
			@if ($unsuported()) {
				<div
					class="gap-2 w-full flex flex-col items-center justify-center pointer-events-all"
				>
					<i class="icon-warning-white text-importance imp-8 text-sp-5"></i>
					<p class="fc-400">The file type is not supported for the preview.</p>
				</div>
			} @else if ($showLoadingOverlay()) {
				<div class="top-0 left-0 w-full absolute">
					<div
						class="rounded-0.25 h-0.5 [background:linear-gradient(90deg,_rgba(var(--color-primary-rgb),_0.2)_0%,_rgba(var(--color-primary-rgb),_1)_100%)]"
						[style.width.%]="$loadingPercent()"
					></div>
				</div>

				<div class="gap-2 w-full flex flex-col items-center justify-center">
					<i tenantMarkIconClass class="text-primary text-sp-5"></i>
					<p class="fc-400">Loading file...</p>
				</div>
			} @else if ($failed()) {
				<div
					class="gap-2 w-full flex flex-col items-center justify-center pointer-events-all"
				>
					<i class="icon-cross-empty text-warn text-sp-5"></i>
					<p class="fc-400">The file could not be loaded, please try again.</p>
					<button buttonOutlined (click)="retry()">Retry</button>
				</div>
			}
		</div>
	</div>
</div>
